import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../util/reactIntl';

import { LISTING_STATE_DRAFT } from '../../util/types';
import { ensureListing } from '../../util/data';
import { EditListingSecurityLevelsForm } from '../../forms';
import { ListingLink } from '../../components';

import css from './EditListingSecurityLevelsPanel.module.css';

const SENIORITY_LEVELS_NAME = 'securityLevels';

const EditListingSecurityLevelsPanel = props => {
  const {
    rootClassName,
    className,
    listing,
    disabled,
    ready,
    onSubmit,
    onChange,
    submitButtonText,
    panelUpdated,
    updateInProgress,
    errors,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const currentListing = ensureListing(listing);
  const { publicData } = currentListing.attributes;

  const isPublished = currentListing.id && currentListing.attributes.state !== LISTING_STATE_DRAFT;
  const panelTitle = isPublished ? (
    <FormattedMessage
      id="EditListingSecurityLevelsPanel.title"
      values={{ jobRole: listing.attributes.publicData.jobRoleName }}
    />
  ) : (
    <FormattedMessage
      id="EditListingSecurityLevelsPanel.createListingTitle"
      values={{ jobRole: listing.attributes.publicData.jobRoleName }}
    />
  );

  const securityLevels = publicData && publicData.securityLevels;
  const initialValues = { securityLevels };

  return (
    <div className={classes}>
      <h1 className={css.title}>{panelTitle}</h1>
      <EditListingSecurityLevelsForm
        className={css.form}
        name={SENIORITY_LEVELS_NAME}
        initialValues={initialValues}
        onSubmit={values => {
          const { securityLevels = [] } = values;

          const updatedValues = {
            publicData: { securityLevels },
          };
          onSubmit(updatedValues);
        }}
        onChange={onChange}
        saveActionMsg={submitButtonText}
        disabled={disabled}
        ready={ready}
        updated={panelUpdated}
        updateInProgress={updateInProgress}
        fetchErrors={errors}
      />
    </div>
  );
};

EditListingSecurityLevelsPanel.defaultProps = {
  rootClassName: null,
  className: null,
  listing: null,
};

const { bool, func, object, string } = PropTypes;

EditListingSecurityLevelsPanel.propTypes = {
  rootClassName: string,
  className: string,

  // We cannot use propTypes.listing since the listing might be a draft.
  listing: object,

  disabled: bool.isRequired,
  ready: bool.isRequired,
  onSubmit: func.isRequired,
  onChange: func.isRequired,
  submitButtonText: string.isRequired,
  panelUpdated: bool.isRequired,
  updateInProgress: bool.isRequired,
  errors: object.isRequired,
};

export default EditListingSecurityLevelsPanel;
